// Select search that reads the option's own text (screens QA SQ-12, 4 Nov 2026).
// antd 5 hands filterOption the option's data (children, label, value), not a React element, so
// option.props.children was undefined and typing in a searchable dropdown threw.

export const optionText = (option) => {
  if (!option) return "";
  const text = option.children ?? option.label;
  if (text === null || text === undefined) return "";
  return Array.isArray(text) ? text.join("") : String(text);
};

// filterOption={filterByText}: case insensitive "contains" match on the option text.
export const filterByText = (input, option) =>
  optionText(option)
    .toLowerCase()
    .includes(String(input ?? "").toLowerCase());

export default filterByText;
